import React from "react";
import { useState, createContext } from "react";

const Context = createContext();
export default Context;
